import React from "react";
import CommonTextField from "../../../components/CommonTextField";

interface UserProfileFormProps {
  formData: {
    name: string;
    date_of_birth: string;
    email_id: string;
    address_line_1: string;
    phone_number: string;
  };
  handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

const UserProfileForm: React.FC<UserProfileFormProps> = ({ formData, handleChange }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <CommonTextField label="Full Name" name="name" value={formData.name} onChange={handleChange} required />
      <CommonTextField label="Date of Birth" name="date_of_birth" value={formData.date_of_birth} onChange={handleChange} disabled />
      <CommonTextField label="Email ID" name="email_id" type="email" value={formData.email_id} onChange={handleChange} required />
      <CommonTextField label="Address" name="address_line_1" value={formData.address_line_1} onChange={handleChange} multiline rows={2} fullWidth />
      <CommonTextField label="Phone Number" name="phone_number" value={formData.phone_number} onChange={handleChange} />
    </div>
  );
};

export default UserProfileForm;